module.exports = __webpack_public_path__ + "img/bg.ca827cc2.png";